enum HTMLInputType {
  text = "text",
  email = "email",
  password = "password",
  number = "number",
  tel = "tel",
  url = "url",
  date = "date",
  time = "time",
  datetimeLocal = "datetime-local",
  month = "month",
  week = "week",
  color = "color",
  checkbox = "checkbox",
  radio = "radio",
  file = "file",
  hidden = "hidden",
  image = "image",
  reset = "reset",
  submit = "submit",
  button = "button",
}

export interface IRegisterFormFieldData {
  id: string;
  type: HTMLInputType;
  placeholder: string;
  name: string;
  autocomplete?: AutoFill;
  value?: string | number;
}

export const FIELDS: { [key: string]: IRegisterFormFieldData } = {
  email: {
    id: "email",
    type: HTMLInputType.email,
    placeholder: "Email Address",
    name: "email",
    autocomplete: "username",
  },
  password: {
    id: "password",
    type: HTMLInputType.password,
    placeholder: "Password",
    name: "password",
    autocomplete: "new-password",
  },
  confirmPassword: {
    id: "confirmPassword",
    type: HTMLInputType.password,
    placeholder: "Confirm Password",
    name: "confirmPassword",
    autocomplete: "current-password",
  },
  firstName: {
    id: "firstName",
    type: HTMLInputType.text,
    placeholder: "First Name",
    name: "firstName",
  },
  lastName: {
    id: "lastName",
    type: HTMLInputType.text,
    placeholder: "Last Name",
    name: "lastName",
  },
};
